import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
@Component({
    selector: 'app-invoice-details-modal',
    templateUrl: './invoice-details-modal.component.html',
    standalone: false
})
export class InvoiceDetailsModalComponent implements OnInit {
    //#region Feilds
    invoiceDetails: any[] = [];
    itemsPerPage: number = 5;

    invoiceTotalPages: number = 0;
    invoiceCurrentPage: number = 1;
    paginatedInvoiceData: any[] = [];
    invoicePages: number[] = [];

    //#endregion

    //#region Constructor
    constructor(
        public activeModal: NgbActiveModal,
    ) { }
    //#endregion

    //#region Utilities


    //#endregion

    //#region Methods
    ngOnInit(): void {
        this.invoiceCurrentPage = 1;
        this.updateInvoicePaginatedData();
    }

    cancelPopup() {
        this.activeModal.close();
    }

    onSelectionChanged(event: any) {

    }

    updateInvoicePaginatedData() {
        this.invoiceTotalPages = Math.ceil(this.invoiceDetails.length / this.itemsPerPage);
        const startIndex = (this.invoiceCurrentPage - 1) * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;
        this.paginatedInvoiceData = this.invoiceDetails.slice(startIndex, endIndex);
        this.updateInvoicePageNumbers();
    }

    updateInvoicePageNumbers() {
        this.invoicePages = [];
        for (let i = 1; i <= this.invoiceTotalPages; i++) {
            this.invoicePages.push(i);
        }
    }

    goToInvoicePage(page: number) {
        if (page >= 1 && page <= this.invoiceTotalPages) {
            this.invoiceCurrentPage = page;
            this.updateInvoicePaginatedData();
        }
    }
    //#endregion
}